var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip",style:(` width:${_vm.width}; left:${_vm.left}; right:${_vm.right}`)},[_c('div',{staticClass:"tooltip__dialog flex flex-col"},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"tooltip__header text-white mb-1"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"tooltip__body text-white"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }